import React from 'react';
import { Icon, Message, Button, Modal, Header } from 'semantic-ui-react'
import _ from 'lodash';

const styles1 ={
  styMargin1:{
    // margin: '0.4em',
    // padding: '0.5em 0.5em 0.5em 1em',
  },
  styTable:{
    margin: '0.2em',
    // padding: '0.2em 0.2em 0.2em 0.2em',
  },
  styPaddMarg:{
    // padding: '0.2em 0.1em 0.2em 0.1em',
    // // margin: '0em 0em 0em 0em',
    // fontSize: '0.9em'
  },
  styInput:{
    width: '4.2em',
  },
  styInput1:{
    width: '3.6em',
  },
  styInput2:{
    // width: '5.4em',
  },
}

const Servicios = ({elemento, handleChange}) => {
  return(
    <tr className=''>
      <td className='collapsing'>
        <div className='ui fitted slider checkbox'>
          <input type='checkbox' name='estadoServ' id={elemento.codigoServicio} checked={elemento.estadoServ} onChange={(ev)=>handleChange(ev, elemento)}/>
          <label />
        </div>
      </td>
      <td className=''>{elemento.descrClaseServ}</td>
      <td className=''>{elemento.nombreResumido}</td>
      <td className=''>{elemento.descripcionServicio}</td>
    </tr>
  )
};

const ListaServ = ({list, handleChange}) => {
  const nivel1Detalle = list.map((elemento, _id) => <Servicios elemento={elemento} handleChange={handleChange} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

//

const ServiciosTar = ({elemento, handleChange}) => {

  const rango1Ini = (valor) => {
    if(valor!==null){
      return valor
    }else{
      return ''
    }
  }

  return(
    <tr className=''>
      <td className='collapsing'>
        <div className='ui fitted slider checkbox'>
          <input type='checkbox' name='estadoServTar' id={elemento.codigoServicio} checked={elemento.estadoServ} onChange={(ev)=>handleChange(ev, elemento)}/>
          <label />
        </div>
      </td>
      <td className=''>{elemento.descrClaseServ}</td>

      <td className=''>{elemento.nombreResumido}</td>
      <td className=''>{elemento.descripcionServicio}</td>

      {/* <td className='center aligned' style={styles1.styPaddMarg}>
        <input type='number' step="1" style={styles1.styInput1} autoComplete="off" name="rango1NumServValorIni" id={elemento.codigoServicio} value='1' placeholder='Min' onChange={(ev)=>handleChange(ev, elemento)}/>
      </td>
      <td className='center aligned' style={styles1.styPaddMarg}>
        <input type='number' step="1" style={styles1.styInput1} autoComplete="off" name="rango1NumServValorFin" id={elemento.codigoServicio} value='1' placeholder='Max' onChange={(ev)=>handleChange(ev, elemento)}/>
      </td> */}
      <td className='right aligned' style={styles1.styPaddMarg}>
        <input type='number' step="1" style={styles1.styInput2} autoComplete="off" name="rango1Valor" id={elemento.codigoServicio} value={rango1Ini(elemento.rango1Valor)} placeholder='$V/r' onChange={(ev)=>handleChange(ev, elemento)}/>
      </td>

      {/* <td className='center aligned' style={styles1.styPaddMarg}>
        <input type='number' step="1" style={styles1.styInput1} autoComplete="off" name="rango2NumServValorIni" id={elemento.codigoServicio} value={rango1Ini(elemento.rango2NumServValorIni)} placeholder='Min' onChange={(ev)=>handleChange(ev, elemento)}/>
      </td>
      <td className='center aligned' style={styles1.styPaddMarg}>
        <input type='number' step="1" style={styles1.styInput1} autoComplete="off" name="rango2NumServValorFin" id={elemento.codigoServicio} value={rango1Ini(elemento.rango2NumServValorFin)} placeholder='Max' onChange={(ev)=>handleChange(ev, elemento)}/>
      </td>
      <td className='right aligned' style={styles1.styPaddMarg}>
        <input type='number' step="1" style={styles1.styInput2} autoComplete="off" name="rango2Valor" id={elemento.codigoServicio} value={rango1Ini(elemento.rango2Valor)} placeholder='$V/r' onChange={(ev)=>handleChange(ev, elemento)}/>
      </td>

      <td className='center aligned' style={styles1.styPaddMarg}>
        <input type='number' step="1" style={styles1.styInput1} autoComplete="off" name="rango3NumServValorIni" id={elemento.codigoServicio} value={rango1Ini(elemento.rango3NumServValorIni)} placeholder='Min' onChange={(ev)=>handleChange(ev, elemento)}/>
      </td>
      <td className='center aligned' style={styles1.styPaddMarg}>
        <input type='number' step="1" style={styles1.styInput1} autoComplete="off" name="rango3NumServValorFin" id={elemento.codigoServicio} value={rango1Ini(elemento.rango3NumServValorFin)} placeholder='Max' onChange={(ev)=>handleChange(ev, elemento)}/>
      </td>
      <td className='right aligned' style={styles1.styPaddMarg}>
        <input type='number' step="1" style={styles1.styInput2} autoComplete="off" name="rango3Valor" id={elemento.codigoServicio} value={rango1Ini(elemento.rango3Valor)} placeholder='$V/r' onChange={(ev)=>handleChange(ev, elemento)}/>
      </td> */}

    </tr>
  )
};

const ListaServTar = ({list, handleChange}) => {
  const nivel1Detalle = list.map((elemento, _id) => <ServiciosTar elemento={elemento} handleChange={handleChange} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

//

class ConfSerT2 extends React.Component {
  state={
      listServ: this.props.lisServ,
      listServTar: this.props.lisServTar,
      errors: this.props.errors,
      open: false,
  }

  // ordenarArrayAsc = (array, campo) => {
  //   array.sort(function (a, b) {
  //      return a[campo] > b[campo];
  //   });
  // }

  handleRefresh = () => {
    let arrayServTar=this.state.listServTar
    let arrayServ=this.state.listServ
    arrayServ.forEach((elemento, _id) => {
      if(elemento.estadoServ===true){
          arrayServTar.push({codigoServicio: elemento.codigoServicio, descrClaseServ: elemento.descrClaseServ, nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
            rango1NumServValorIni: '1', rango1NumServValorFin: '1', rango1Valor: null,
            rango2NumServValorIni: null, rango2NumServValorFin: null, rango2Valor: null,
            rango3NumServValorIni: null, rango3NumServValorFin: null, rango3Valor: null,
            velEfecDownstream: elemento.velEfecDownstream, velEfecUpstream: elemento.velEfecUpstream,
            codigoTipoTec: elemento.codigoTipoTec, descrTipoTec: elemento.descrTipoTec,
            colorServicio: elemento.colorServicio,
              _id: elemento._id, estadoServ: true});
          }
    })

    let arrayServ1 = arrayServ.filter(item => item.estadoServ===true);
    arrayServ1.forEach((elemento1, _id) => {
      arrayServ.forEach((elemento, _id) => {
        if(elemento.estadoServ===true && elemento1.codigoServicio===elemento.codigoServicio){
          const indexServ = arrayServ.findIndex( servicio => servicio.codigoServicio === elemento.codigoServicio );
          arrayServ.splice(indexServ, 1);
        }
      })
    })

    arrayServTar.forEach((elemento, _id) => {
      if(elemento.estadoServ===false){
          arrayServ.push({codigoServicio: elemento.codigoServicio, descrClaseServ: elemento.descrClaseServ, nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
            rango1NumServValorIni: '1', rango1NumServValorFin: '1', rango1Valor: null,
            rango2NumServValorIni: null, rango2NumServValorFin: null, rango2Valor: null,
            rango3NumServValorIni: null, rango3NumServValorFin: null, rango3Valor: null,
            velEfecDownstream: elemento.velEfecDownstream, velEfecUpstream: elemento.velEfecUpstream,
            codigoTipoTec: elemento.codigoTipoTec, descrTipoTec: elemento.descrTipoTec,
            colorServicio: elemento.colorServicio,
            _id: elemento._id, estadoServ: false});
          }
    })
    
    arrayServ1 = arrayServTar.filter(item => item.estadoServ===false);
    arrayServ1.forEach((elemento1, _id) => {
      arrayServTar.forEach((elemento, _id) => {
        if(elemento.estadoServ===false && elemento1.codigoServicio===elemento.codigoServicio){
          const indexServ = arrayServTar.findIndex( servicio => servicio.codigoServicio === elemento.codigoServicio );
          arrayServTar.splice(indexServ, 1);
        }
      })
    })

    arrayServTar = _.orderBy(arrayServTar, ['descrClaseServ', 'descripcionServicio'])
    arrayServ = _.orderBy(arrayServ, ['descrClaseServ', 'descripcionServicio'])

    // this.ordenarArrayAsc(arrayServTar, 'descrClaseServ')
    // this.ordenarArrayAsc(arrayServ, 'descrClaseServ')

    this.setState({listServTar: arrayServTar})
    this.setState({listServ: arrayServ})
    this.setState({open: false})
    this.setState({errors: []})
  }

  handleChange = (ev, elemento) => {
    if(ev.target.name === "estadoServTar" ||
        ev.target.name === "rango1NumServValorIni" ||
        ev.target.name === "rango1NumServValorFin" ||
        ev.target.name === "rango1Valor" ||
        ev.target.name === "rango2NumServValorIni" ||
        ev.target.name === "rango2NumServValorFin" ||
        ev.target.name === "rango2Valor" ||
        ev.target.name === "rango3NumServValorIni" ||
        ev.target.name === "rango3NumServValorFin" ||
        ev.target.name === "rango3Valor"
      ){
        
      let listServTar=this.state.listServTar
      const indexServ = listServTar.findIndex( servicio => servicio.codigoServicio === ev.target.id );
      if(ev.target.name === "estadoServTar"){
        if(elemento.estadoServ===false){
          listServTar[indexServ].estadoServ = true
        }else{
          listServTar[indexServ].estadoServ = false
        }
      }
      if(ev.target.name === "rango1NumServValorIni"){
        listServTar[indexServ].rango1NumServValorIni = ev.target.value
      }
      if(ev.target.name === "rango1NumServValorFin"){
        listServTar[indexServ].rango1NumServValorFin = ev.target.value
      }
      if(ev.target.name === "rango1Valor"){
        listServTar[indexServ].rango1Valor = ev.target.value
      }
      if(ev.target.name === "rango2NumServValorIni"){
        listServTar[indexServ].rango2NumServValorIni = ev.target.value
      }
      if(ev.target.name === "rango2NumServValorFin"){
        listServTar[indexServ].rango2NumServValorFin = ev.target.value
      }
      if(ev.target.name === "rango2Valor"){
        listServTar[indexServ].rango2Valor = ev.target.value
      }
      if(ev.target.name === "rango3NumServValorIni"){
        listServTar[indexServ].rango3NumServValorIni = ev.target.value
      }
      if(ev.target.name === "rango3NumServValorFin"){
        listServTar[indexServ].rango3NumServValorFin = ev.target.value
      }
      if(ev.target.name === "rango3Valor"){
        listServTar[indexServ].rango3Valor = ev.target.value
      }

      this.setState({listServTar});
    }

    if(ev.target.name === "estadoServ"){
      let listServ=this.state.listServ
      const indexServ = listServ.findIndex( servicio => servicio.codigoServicio === ev.target.id );
      if(elemento.estadoServ===false){
        listServ[indexServ].estadoServ = true
      }else{
        listServ[indexServ].estadoServ = false
      }
      this.setState({listServ});
    }
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel"){this.setState({open: true})};

    if(btnPress==="No"){
        this.setState({open: false})
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps){

    if(this.props.lisServ!==nextProps.lisServ){
        this.setState({listServ: this.props.lisServIni})
        this.setState({listServTar: this.props.lisServTarIni})
    }
    if(this.props.errors!==nextProps.errors){
      this.setState({errors: nextProps.errors})
    }
    this.setState({open: false})
  }

  shouldComponentUpdate(nextProps, nextState){
    if(this.props.lisServ!==nextProps.lisServ || this.state.listServ!==nextState.lisServ){
      return true
    }else{
      return false
    }
  }

  UNSAFE_componentWillUpdate(nextProps){
//entra si shouldComponentUpdate return true

}
  
  render(){
    const {listServ, listServTar, open} = this.state;
    const a25101505 = this.props.autorizacUA.findIndex( autorizac => autorizac === "25101505" );

    // console.log(this.state)
    // console.log(this.props)
    // console.log(listServ)
    // console.log(listServTar)
    // console.log(this.props.listServ)
    // console.log(this.props.listServTar)
    // console.log(this.props.lisServIni)
    // console.log(this.props.lisServTarIni)

    return(
      <div>
        <Modal open={open} size="tiny" style={this.props.styles.modal} trigger={
          <div>
            <Button className='ui right labeled icon button' style={this.props.styles.titBuscar}>
                <i className='large hand point down yellow icon'></i>
                Tarifa: {this.props.tarifa}
            </Button>
            <Button name="btnRefr" id="btnRefr"  className='ui right labeled icon button' style={this.props.styles.titBuscar} onClick={this.handleRefresh}>
                <i className='large redo yellow icon'></i>
                Refrescar
            </Button>
            <Button name="btnVrInic" id="btnVrInic" className='ui right labeled icon button' style={this.props.styles.titBuscar} onClick={this.props.handleVrinic}>
                <i className='large refresh yellow icon'></i>
                Valores iniciales
            </Button>
            {a25101505!==-1 &&
            <Button name="btnUpdDel" id="btnUpdDel" className='ui right labeled icon button' style={this.props.styles.titBuscar} onClick={(ev)=>this.handleQuestionUpdDel(ev)}>
                <i className='large save yellow icon'></i>
                Guardar
            </Button>
            }
          </div>
        }>

          <Header icon='edit' color='red' content='Modificar tarifa' />
      
          <Modal.Content>
              <p>Esta usted seguro ?</p>
          </Modal.Content>
          <Modal.Actions>
              <Button dato1="No" name='btnNoUpd' color='red' onClick={(ev)=>this.handleQuestionUpdDel(ev)}>
                  <Icon dato1="No" name='remove' /> No
              </Button>
              <Button dato1="Si" name='btnSiUpd' color='green' onClick={(ev)=>this.props.handleSubmit(ev, listServTar)}>
                  <Icon dato1="Si" name='checkmark' /> Si
              </Button>
          </Modal.Actions>
        </Modal>

        {
            this.state.errors.length?<Message negative header="Los siguientes errores:"
            list={this.state.errors.map(error=>`${error.path}: ${error.message}`)} />:null
        }

      <div style={this.props.styles.box}>
        <div className='ui blue inverted raised segment'>
          <p className='ui large label' style={this.props.styles.styTableSup}>Servicios asignados a la tarifa</p>
          <table className='ui olive inverted celled selectable table'  style={this.props.styles.styTableSup}>
            <thead className=''>
              <tr className=''>
                <th rowSpan='2' className=''></th>
                <th rowSpan='2' className=''>Clase</th>
                <th rowSpan='2' className=''>Servicio</th>
                <th rowSpan='2' className=''>Descripción servicio</th>
                <th colSpan='3' className=''>Valor</th>
                {/* <th colSpan='3' className='center aligned'>Rango 1</th> */}
                {/* <th colSpan='3' className='center aligned'>Rango 2</th>
                <th colSpan='3' className='center aligned'>Rango 3</th> */}
              </tr>
              {/* <tr className=''>
                <th className='center aligned'>Min</th>
                <th className='center aligned'>Max</th>
                <th className='center aligned'>$</th>
                <th className='center aligned'>Min</th>
                <th className='center aligned'>Max</th>
                <th className='center aligned'>$</th>
                <th className='center aligned'>Min</th>
                <th className='center aligned'>Max</th>
                <th className='center aligned'>$</th>
              </tr> */}
            </thead>
            <ListaServTar list={listServTar} handleChange={this.handleChange}/>
          </table>          
        </div>

        <div className='ui blue inverted raised segment'>
          <p className='ui large label' style={this.props.styles.styTableInf}>Servicios sin asignar a la tarifa</p>
          <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableInf}>
            <thead className=''>
              <tr className=''>
                <th className=''></th>
                <th className=''>Clase</th>
                <th className=''>Servicio</th>
                <th className=''>Descripción servicio</th>
              </tr>
            </thead>
            <ListaServ list={listServ} handleChange={this.handleChange}/>
          </table>
        </div>
      </div>
      </div>
    )
  }
}

export default ConfSerT2